var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.box,( _obj = {}, _obj[_vm.$style.title] = _vm.type==='title', _obj[_vm.$style.image] = _vm.type==='image', _obj )]},[(_vm.type==='image')?_c('img',{attrs:{"src":_vm.data.url}}):_vm._e(),_vm._l((_vm.text),function(item,index){
  var _obj;
return _c('span',{key:index,class:[_vm.$style.text,( _obj = {}, _obj[_vm.$style.url] = item.url, _obj[_vm.$style.image] = _vm.type==='image', _obj )]},[(!item.url)?[_vm._v(" "+_vm._s(item.text)+" ")]:_c('a',{attrs:{"href":item.url}},[_vm._v(" "+_vm._s(item.text)+" ")])],2)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }